<BolideLoader v-show="is_loading" />
<div class="dashboard-container container-fluid px-0" v-show="!is_loading">
  <div class="row g-0 vh-100 overflow-visible">
    <div
      v-if="!is_mobile"
      class="col-auto sidebar-wrapper sidebar-offset d-flex flex-column flex-shrink-0 position-sticky vh-100 overflow-hidden overflow-x-visible"
      :class="{ 'sidebar-collapsed': sidebar_collapsed }"
    >
      <PortfolioSidebar
        :tiles="tiles"
        @global-menu-selected="handleGlobalMenuSelected"
        @open-programme="handleProgrammeOpen"
      />
    </div>

    <div
      v-if="is_mobile && mobile_sidebar_open"
      class="mobile-sidebar-overlay"
      @click.self="close_sidebar"
    >
      <div class="mobile-sidebar-panel">
        <PortfolioSidebar
          :tiles="tiles"
          @global-menu-selected="handleGlobalMenuSelected"
          @open-programme="handleProgrammeOpen"
        >
          <template #sidebar-header-actions>
            <button
              class="sidebar-close-btn rounded-5 border"
              @click="close_sidebar"
              aria-label="Close sidebar"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PortfolioSidebar>
      </div>
    </div>

    <button
      v-if="!is_mobile"
      class="sidebar-collapse-btn btn btn-sm btn-dark float-start"
      @click="toggleSidebar"
    >
      <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
    </button>

    <div class="col px-3 vh-100 overflow-auto overflow-x-hidden">
      <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="showAssistant = true"
        @toggle-mobile-sidebar="toggle_mobile_sidebar"
      />

      <BolideAssistant
        :is_open="showAssistant"
        :tiles="tiles"
        :active_menu_item="active_menu_item"
        :breadcrumb="breadcrumb"
        @close-assistant="showAssistant = false"
      />

      <main class="dashboard-main">
        <div v-if="is_integration_view" class="integration-view mt-1">
          <IntegrationComponent :is_integration_view="is_integration_view" class="integration-container" />
        </div>

        <div v-else-if="is_verification_view" class="verification-view mt-1">
          <VerificationComponent :is_verification_view="is_verification_view" class="verification-container" />
        </div>

        <div v-else-if="is_help_view" class="help-support-view mt-1">
          <HelpSupport class="help-support-container" />
        </div>

        <div v-else-if="is_settings_view" class="special-view mt-1">
          <SettingsComponent class="special-view-container" />
        </div>

        <div v-else-if="is_programme_view" class="programme-view mt-1">
          <ProgrammeComponent class="programme-view-container" :programme-slug="selected_programme_slug" />
        </div>

        <div v-else-if="is_company_profile_view" class="special-view mt-1">
          <CompanyProfile class="special-view-container" />
        </div>

        <div v-else-if="is_certificates_reports_view" class="special-view mt-1">
          <CertificatesAndReports />
        </div>

        <div v-else class="dashboard-main-view mt-1">
          <div class="row g-0">
            <PortfolioSuperSetChart
              content_class="col-12"
              chart_id="dashboard-main"
              :iframe_loading="iframeLoading"
              :show_iframe="active_menu_item === 'portfolio-comparisons'"
            />
          </div>
        </div>

        <button
          v-if="is_mobile && !showAssistant"
          class="floating-assistant-btn btn btn-primary d-md-none"
          @click="showAssistant = true"
          aria-label="Open assistant"
        >
          <i class="bi bi-robot fs-5"></i>
        </button>
      </main>
    </div>
  </div>
</div>
